var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountReceivable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 170,
    viewBox: "0 0 146 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_5633_110489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3517 9.51725C65.0613 9.10409 65.9517 9.61602 65.9517 10.4372V24.5959C65.9517 25.1633 65.6507 25.688 65.1609 25.9744L48.3117 35.8247C47.602 36.2396 46.71 35.7278 46.71 34.9058V21.6243C46.71 20.4876 47.3142 19.4365 48.2966 18.8645L64.3517 9.51725Z",
    fill: "url(#paint0_linear_5633_110489)",
    fillOpacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.5587 5.39615C58.2683 4.983 59.1588 5.49492 59.1588 6.31607V19.5203C59.1588 20.6532 58.5586 21.7013 57.5815 22.2746L41.5202 31.6993C40.8106 32.1157 39.917 31.604 39.917 30.7812V17.5032C39.917 16.3665 40.5213 15.3154 41.5037 14.7434L57.5587 5.39615Z",
    fill: "url(#paint1_linear_5633_110489)",
    fillOpacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.7667 1.27115C51.4763 0.857996 52.3668 1.36992 52.3668 2.19107V15.3953C52.3668 16.5282 51.7666 17.5763 50.7895 18.1496L34.7282 27.5743C34.0186 27.9907 33.125 27.479 33.125 26.6562V13.3782C33.125 12.2415 33.7293 11.1904 34.7117 10.6184L50.7667 1.27115Z",
    fill: "url(#paint2_linear_5633_110489)",
    fillOpacity: 0.91
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_5633_110489",
    x: -48,
    y: 0,
    width: 196,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.0899666 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5633_110489"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.129246 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5633_110489",
    result: "effect2_dropShadow_5633_110489"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5633_110489",
    result: "effect3_dropShadow_5633_110489"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.190754 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_5633_110489",
    result: "effect4_dropShadow_5633_110489"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.230033 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_5633_110489",
    result: "effect5_dropShadow_5633_110489"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_5633_110489",
    result: "effect6_dropShadow_5633_110489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_5633_110489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5633_110489",
    x1: 42.7982,
    y1: 42.5766,
    x2: 70.8999,
    y2: 8.5856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0295C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CD2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5633_110489",
    x1: 56.1035,
    y1: 23.9504,
    x2: 55.5712,
    y2: 5.85435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5633_110489",
    x1: 49.3115,
    y1: 19.8256,
    x2: 48.7792,
    y2: 1.72949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountReceivable);
export default __webpack_public_path__ + "static/media/accountReceivable.a87823b85201c253d1776ade09e405b3.svg";
export { ForwardRef as ReactComponent };